import { MentoringReapplyForm } from 'hb-react/frontoffice/apps/Mentoring/container/Application/Shared/MentoringReapplyForm';
import { useEditMentor } from 'hb-react/frontoffice/apps/Mentoring/hooks/useMutateMentor';
import type {
  CustomAttributeType,
  MentorProfile,
  Program,
} from 'hb-react/frontoffice/apps/Mentoring/types';
import { LockScreen } from 'hb-react/shared/components/LockScreen';

interface ReapplyMentorFormProps {
  program: Program;
  mentorProfile: MentorProfile & { status: 'rejected_can_reapply' };
  attributes: CustomAttributeType[];
  onSuccess: () => void;
  applicationDescription: string;
  title: string;
}

export const ReapplyMentor = ({
  program,
  mentorProfile,
  attributes,
  applicationDescription,
  title,
  onSuccess,
}: ReapplyMentorFormProps) => {
  const { id: mentorId } = mentorProfile;
  const { mutateAsync: onReapply, isPending: isPendingReapply } = useEditMentor(
    {
      program,
      mentorId,
    },
  );

  return (
    <>
      {isPendingReapply && <LockScreen />}
      <MentoringReapplyForm
        attributes={attributes}
        applicationDescription={applicationDescription}
        mentoringProfile={mentorProfile}
        title={title}
        onSuccess={onSuccess}
        onReapply={onReapply}
      />
    </>
  );
};
